import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Coins, AlertCircle } from 'lucide-react';

interface PurchaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  item: {
    title: string;
    description: string;
    cost: number;
    currentCoins: number;
  };
}

export function PurchaseModal({ isOpen, onClose, onConfirm, item }: PurchaseModalProps) {
  const canAfford = item.currentCoins >= item.cost;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Purchase {item.title}</DialogTitle>
          <p className="text-sm text-gray-600">
            {item.description}
          </p>
        </DialogHeader>

        <div className="py-4">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Coins className="w-5 h-5 text-yellow-500" />
              <span className="font-medium">Cost:</span>
            </div>
            <span className="text-lg font-bold">{item.cost} coins</span>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Coins className="w-5 h-5 text-yellow-500" />
              <span className="font-medium">Your Balance:</span>
            </div>
            <span className="text-lg font-bold">{item.currentCoins} coins</span>
          </div>

          {!canAfford && (
            <div className="mt-4 p-3 bg-red-50 text-red-700 rounded-lg flex items-center gap-2">
              <AlertCircle className="w-5 h-5" />
              <span>Insufficient coins. Complete more tasks to earn coins!</span>
            </div>
          )}
        </div>

        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button 
            onClick={onConfirm} 
            disabled={!canAfford}
            className="bg-primary-600 hover:bg-primary-700"
          >
            Confirm Purchase
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
} 